export default "__VITE_ASSET__965fc40e__"